import {setThemeMode} from '../utils/setThemeMode.js';

const doTheme = () => {
    // PRS Contact
    setThemeMode('.PRS_CONTACT_NOIR > *', 'dark');

    // PRS Fond noir
    const fondNoir = document.querySelectorAll('.PRS_FOND_NOIR');
    if (fondNoir) {
        setThemeMode('.PRS_FOND_NOIR', 'dark');
    }
    setThemeMode('.PRS_FOND_NOIR', 'dark');

    // TPL Expertise accueil
    setThemeMode('.TPL_LFB_EXPERTISE', 'dark');

}

doTheme();

const paginations = document.querySelectorAll('.js-ajax-content');

paginations.forEach(pagination => {
    pagination.addEventListener('pagination.done', () => {
        doTheme();
    });
});
